export default __webpack_public_path__ + "static/media/Tick.2ef61c40.svg";